export interface ItemIDType {
  CODE: string;
  NAME: {
    vi: string;
    en: string;
  };
}

interface JsonIDType {
  ID_TYPE: ItemIDType[];
}

let idTypeJson: JsonIDType;

export function loadIDTypeJson() {
  return new Promise(async (resolve) => {
    if (!idTypeJson) idTypeJson = await import("../../../shared/util/data-json/infomation-id-type.json");
    resolve(0);
  });
}

export const getIDTypeArray = () => {
  let list: ItemIDType[] = [];
  if (idTypeJson?.ID_TYPE?.length) {
    return idTypeJson.ID_TYPE;
  }
  return list;
};
